import { render } from "./NotificationAttachments.vue?vue&type=template&id=679ac5f4"
import script from "./NotificationAttachments.vue?vue&type=script&lang=js"
export * from "./NotificationAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__